import axios from '@/utils/requset'
import { pageResponseHandler } from '@/utils/http'

const api = {
  getWholeList: '/client/home/getWholeList',
  getWholeCourseList: '/client/whole/getWholeCourseList',
  getCourseDetailList: '/client/whole/getCourseDetailList',
  submitOrder: '/client/whole/submitOrder',
  selectWholeById: '/client/whole/selectWholeById',
  checkPaidWholeCourse: '/client/whole/checkPaidWholeCourse',
  submitOrderWithoutPay: '/client/whole/submitOrderWithoutPay',
}

export default {
  getWholeList(parameter) {
    return axios({
      url: api.getWholeList,
      method: 'get',
      params: parameter
    })
  },
  getWholeCourseList(parameter) {
    return axios({
      url: api.getWholeCourseList,
      method: 'get',
      params: parameter
    }).then(pageResponseHandler)
  },
  getCourseDetailList(parameter) {
    return axios({
      url: api.getCourseDetailList,
      method: 'get',
      params: parameter
    }).then(pageResponseHandler)
  },
  submitOrder(parameter) {
    return axios({
      url: api.submitOrder,
      method: 'post',
      data: parameter
    })
  },
  selectWholeById(parameter) {
    return axios({
      url: api.selectWholeById,
      method: 'get',
      params: parameter
    })
  },
  checkPaidWholeCourse(parameter) {
    return axios({
      url: api.checkPaidWholeCourse,
      method: 'post',
      data: parameter
    })
  },
  // 无支付操作提交
  submitOrderWithoutPay(parameter) {
    return axios({
      url: api.submitOrderWithoutPay,
      method: 'post',
      data: parameter
    })
  },
}
